import { Avatar, Box, styled, SxProps, Typography } from '@mui/material';

import { Color } from '../../constants';
import { hexToRgba } from '../../lib/util/hexToRgba';
import { Participant } from '../../types/Event';
import { Group } from '../../types/Group';

type ParticipantsListProps = {
  participants?: Participant[];
  groups?: Group[];
  isTeam: boolean;
  total: number;
  maxPreview?: number;
};

const ParticipantsList = ({ participants, groups, isTeam, total, maxPreview = 4 }: ParticipantsListProps) => {
  const extraCount = total - maxPreview;
  const showUsers = !isTeam || (isTeam && (!groups || (groups && groups.length <= 0)));
  return (
    <Container>
      {!showUsers
        ? groups?.map((group, _) => <Avatar key={group.id} src={group.groupMedia?.smallUrl} alt={group?.name} sx={AvatarStyle} />)
        : participants?.map((participant, _) => (
            <Avatar key={participant.id} src={participant.user.profileMedia?.smallUrl} alt={participant.user.fullname} sx={AvatarStyle} />
          ))}
      {extraCount > 0 && (
        <ExtraCount>
          <Typography fontWeight={600} fontSize={10}>
            +{extraCount}
          </Typography>
        </ExtraCount>
      )}
    </Container>
  );
};

export default ParticipantsList;

const Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 6,
});

const ExtraCount = styled(Box)({
  width: 30,
  height: 30,
  borderRadius: '50%',
  backgroundColor: Color.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: Color.prussianBlue,
  fontWeight: 400,
  fontSize: 14,
  marginLeft: -8,
  zIndex: 10,
  border: `1px solid ${hexToRgba(Color.prussianBlue, 1)}`,
});

const AvatarStyle: SxProps = { width: 30, height: 30, marginLeft: '-8px', border: `1px solid ${hexToRgba(Color.prussianBlue, 1)}` };
